// extracted by mini-css-extract-plugin
module.exports =  {"tab":"_0bc5e8de02--tab--Ufql_","inner":"_0bc5e8de02--inner--PU4QY","tab--active":"_0bc5e8de02--tab--active--OxDEr"};